export function validateOib(oib: string) {
    oib = oib.toString()

    if (oib.length != 11) return false

    var b = parseInt(oib, 10)
    if (isNaN(b)) return false

    var a = 10
    for (var i = 0; i < 10; i++) {
        a = a + parseInt(oib.substr(i, 1), 10)
        a = a % 10
        if (a === 0) a = 10
        a *= 2
        a = a % 11
    }

    var kontrolni = 11 - a
    if (kontrolni === 10) kontrolni = 0

    return kontrolni === parseInt(oib.substr(10, 1))
}

export function validateIban(iban: string): boolean {
    iban = iban.replace(/\s+/g, '').toUpperCase()

    // Basic structure check
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false

    // Move first 4 chars to end
    const rearranged = iban.slice(4) + iban.slice(0, 4)

    // Replace letters with numbers (A=10, ..., Z=35)
    const numeric = rearranged.replace(/[A-Z]/g, char => (char.charCodeAt(0) - 55).toString())

    // Mod 97 check
    let remainder = numeric
    while (remainder.length > 9) {
        remainder = (parseInt(remainder.slice(0, 9), 10) % 97) + remainder.slice(9)
    }

    return parseInt(remainder, 10) % 97 === 1
}
